import React from 'react';

interface CardProps {
  variant?: 'default' | 'profile' | 'feature';
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
}

const Card: React.FC<CardProps> = ({
  variant = 'default',
  children,
  className = '',
  hoverable = false,
}) => {
  const baseClasses = 'bg-white rounded-lg transition-all duration-300 h-full';

  const variantClasses = {
    default: 'border border-gray-200 p-6 shadow-sm',
    profile: 'border border-gray-200 p-8 shadow-sm text-center',
    feature: 'border-l-4 border-accent bg-gray-50 p-6',
  };

  const hoverClasses = hoverable
    ? 'hover:shadow-md hover:-translate-y-1 cursor-pointer'
    : '';

  const classes = `${baseClasses} ${variantClasses[variant]} ${hoverClasses} ${className}`;

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default Card;
